import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Storefront } from '@phosphor-icons/react';

export default function SellerLogin() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post('/sellers/login', { email: email.trim(), password });
      localStorage.setItem('zk_token', data.token);
      if (setUser) setUser(data.user);
      toast.success('Welcome back!');
      navigate('/seller/dashboard');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-cream-100 bg-grain px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-stone-200 p-7 shadow-sm" data-testid="seller-login-page">
        <div className="flex items-center gap-2 mb-6">
          <span className="w-10 h-10 rounded-2xl bg-olive-700 text-white grid place-items-center"><Storefront size={22}/></span>
          <div>
            <p className="font-heading text-xl text-stone-900">MyZippyKart</p>
            <p className="text-xs text-stone-500">Seller sign in</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="text-xs font-medium text-stone-600">Email</label>
            <input data-testid="seller-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full h-11 px-4 mt-1 rounded-xl bg-white border border-stone-200 focus:border-olive-400 focus:outline-none text-sm"/>
          </div>
          <div>
            <label className="text-xs font-medium text-stone-600">Password</label>
            <input data-testid="seller-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full h-11 px-4 mt-1 rounded-xl bg-white border border-stone-200 focus:border-olive-400 focus:outline-none text-sm"/>
          </div>
          <button data-testid="seller-login-btn" disabled={busy} type="submit" className="w-full h-12 rounded-full bg-terracotta-600 text-white font-semibold hover:bg-terracotta-700 disabled:bg-stone-300">
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <p className="text-xs text-stone-500 mt-5">
          No account yet? <Link to="/seller/register" className="text-olive-800 font-semibold">Register your store</Link>
        </p>
        <a href="/" className="inline-block mt-4 text-xs text-stone-500 hover:text-stone-700">← Back to store</a>
      </div>
    </div>
  );
}
